import { getPartnerContacts } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
import { PAGINATION_LIMIT } from "../../constants/Preferences";
export const usePartnerContacts = (mpacBaseUrl, partnerId, search, role, offset) => {
  const queryParams = {
    offset,
    search,
    role,
    limit: PAGINATION_LIMIT
  };
  const {
    result,
    error,
    pending,
    refresh
  } = hooks.usePromise(() => getPartnerContacts(mpacBaseUrl, partnerId, queryParams), [offset, partnerId, search, role]);

  if (error) {
    log.error('PartnerContacts/hooks', "Failed to retrieve Partner Contacts List", {
      error
    });
  }

  return {
    pending,
    error,
    refresh,
    partnerContactList: result
  };
};